import { render, staticRenderFns } from "./BarChartChatSource.vue?vue&type=template&id=f0b2dadc"
import script from "./BarChartChatSource.vue?vue&type=script&lang=js"
export * from "./BarChartChatSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports